const productsDescriptor = {
    key: 'products-expenses',
    title: 'Product Expenses',
    subtitle: 'Production and inventory-related costs',
    description: 'Stay on top of production, COGS, and inventory spend to protect margins and maintain healthy stock levels.',
    badge: { direction: 'down', text: '' },
    kpis: [
        { label: 'Total Product Cost', value: '', subtext: '', subColor: '#eb9d00' },
        { label: 'Perfect P&L Variance', value: '', subtext: '', subColor: '#eb9d00' },
        { label: 'Perfect P&L Income', value: '', subtext: '', subColor: '#43a047' },
    ],
    alert: {
        title: 'Your margins are looking good!',
        body: 'Your product margins are healthy (46.6% blended). Products represent 8.0% of revenue—this is appropriate for chiropractic. You have one clear opportunity: Custom Orthotics at 74% margin with only 12 sales/month. More volume here = high-margin profit.',
    },
    lineChart: {
        label: 'Product Spend',
        values: [],
        target: null,
    },
    donut: {
        slices: [],
    },
    table: {
        rows: [],
        total: { thisMonth: null, lastMonth: null, changePct: null },
    },
    vendors: [],
};

export default productsDescriptor;
